import { carrierTypes } from 'common/constants';
import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class CarrierEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}

	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'CARRIERVIEW.NAME',
					rules: 'required|string',
				},
				{
					name: 'carrierTypeId',
					label: 'CARRIERVIEW.CARRIERTYPE',
					rules: 'required',
				},
				{
					name: 'carrierWarehouseIds',
					label: 'CARRIERVIEW.WAREHOUSES',
				},
				{
					name: 'surplusCharge',
					label: '',
					rules: 'numeric|numericMinValue|decimalLength',
					value: 0,
				},
				{
					name: 'isPercentage',
					value: false,
					label: '',
					type: 'checkbox',
				},
				{
					name: 'sellerId',
					label: 'CARRIERVIEW.SELLER',
				},
				{
					name: 'isThirdParty',
					label: 'CARRIERVIEW.ISTHIRDPARTYCARRIER',
				},
				{
					name: 'isCarrier',
					label: 'CARRIERVIEW.CARRIER',
				},
				{
					name: 'isPartialThirdParty',
					value: false,
					label: 'CARRIERVIEW.ISPARTIALTHIRDPARTY',
					type: 'checkbox',
				},
				{
					name: 'shippingAccountId',
					label: 'CARRIERVIEW.SHIPPINGACCOUNT',
				},
				{
					name: 'fedex',
					fields: [
						{
							name: 'clientId',
							label: 'CARRIERVIEW.CLIENTID',
							rules: 'string',
						},
						{
							name: 'clientSecret',
							label: 'CARRIERVIEW.CLIENTSECRET',
							rules: 'string',
						},
						{
							name: 'accountNumber',
							label: 'CARRIERVIEW.ACCOUNTNUMBER',
							rules: 'string',
						},
					],
				},
				{
					name: 'ups',
					rules: '',
					fields: [
						{
							name: 'isAuthorized',
							label: 'CARRIERVIEW.ISAUTHORIZED',
						},
						{
							name: 'clientId',
							label: 'CARRIERVIEW.CLIENTID',
						},
						{
							name: 'clientSecret',
							label: 'CARRIERVIEW.CLIENTSECRET',
						},
						{
							name: 'accessLicenseNumber',
							label: 'CARRIERVIEW.ACCESSLICENSENUMBER',
						},
						{
							name: 'shipperNumber',
							label: 'CARRIERVIEW.SHIPPERNUMBER',
						},
						{
							name: 'refreshToken',
							label: 'CARRIERVIEW.REFRESHTOKEN',
						},
					],
				},
				{
					name: 'usps',
					rules: '',
					fields: [
						{
							name: 'isAuthorized',
							label: 'CARRIERVIEW.ISAUTHORIZED',
							rules: '',
						},
						{
							name: 'refreshToken',
							label: '',
							rules: 'string',
						},
					],
				},
				{
					name: 'passport',
					fields: [
						{
							name: 'apiKey',
							label: 'CARRIERVIEW.APIKEY',
						},
						{
							name: 'company',
							label: 'CARRIERVIEW.COMPANY',
						},
						{
							name: 'deliveryDutyPaid',
							label: 'CARRIERVIEW.DELIVERYDUTYPAID',
							type: 'checkbox',
							default: false,
						},
					],
				},
				{
					name: 'thirdPartyBilling',
					fields: [
						{
							name: 'billToAccountNumber',
							label: 'CARRIERVIEW.BILLTOACCOUNTNUMBER',
						},
						{
							name: 'billToAccountZip',
							label: 'CARRIERVIEW.BILLTOACCOUNTZIP',
						},
					],
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/carrier/forms/CarrierEditForm.js